import { createFileRoute } from '@tanstack/react-router';
import { doNothing } from 'remeda';

import config from '@@config';
import { restoreSavedFilters } from '@@containers/Search/restoreSavedFilters';
import { requireRoles } from '@@router/guards';
import { getContentLocale } from '@@scripts/store/settings/useSettingsStore';

import { Layout } from './-components/Layout';
import { rtElementListQuery } from './-components/rtElementListQuery';
import { rtElementListSearchParams } from './-components/rtElementListSearchParams';

const requireRtElementRoles = requireRoles(config.navigation.rtelements.authorize);

export const Route = createFileRoute('/_authenticated/rtelements')({
    validateSearch: rtElementListSearchParams,
    // A new search makes a new match, which runs the loader again
    loaderDeps: ({ search }) => rtElementListSearchParams.parse(search),
    beforeLoad: ({ cause, location, search }) => {
        requireRtElementRoles();
        restoreSavedFilters({ cause, location, search }, rtElementListSearchParams, 'default');

        // Built on every load, so the options follow the content language as well as the search
        return { listQuery: rtElementListQuery(search, getContentLocale()) };
    },
    loader: ({ context }) => {
        context.queryClient.query(context.listQuery).catch(doNothing());
    },
    component: Layout,
});
